import { useState, useEffect } from 'react';
import { supabase } from '../supabase';

export default function Pricing({ go }) {
  const [pricing, setPricing] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchPricing() {
      const { data } = await supabase.from('pricing').select('*').order('sort_order');
      setPricing(data || []);
      setLoading(false);
    }
    fetchPricing();
  }, []);

  return (
    <div style={{ padding:'48px 1.5rem', background:'var(--warm)', minHeight:'100vh' }}>
      <style>{`
        .pricing-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); gap: 1.5rem; margin-bottom: 2rem; }
        @media (max-width: 480px) {
          .pricing-grid { grid-template-columns: 1fr; }
        }
      `}</style>

      <div className="container">
        <div style={{ textAlign:'center', marginBottom:'3rem' }}>
          <div className="sec-label" style={{ textAlign:'center' }}>Transparent pricing</div>
          <h1 style={{ fontFamily:"'DM Serif Display',serif", fontSize:'clamp(28px,5vw,52px)', color:'var(--teal-deeper)', marginBottom:12 }}>Nanny rates & placement fees</h1>
          <p style={{ fontSize:16, color:'var(--text-mid)', lineHeight:1.7, maxWidth:520, margin:'0 auto' }}>Nanny rates reflect Alberta market standards. Agency placement fees are separate and confirmed in your service agreement.</p>
        </div>

        {loading ? (
          <div style={{ textAlign:'center', padding:'3rem', color:'var(--text-light)' }}>Loading pricing...</div>
        ) : pricing.length === 0 ? (
          <div style={{ textAlign:'center', padding:'4rem 1.5rem', background:'white', borderRadius:16, border:'1px solid var(--border)', marginBottom:'2rem' }}>
            <div style={{ fontSize:48, marginBottom:16 }}>💰</div>
            <h3 style={{ fontFamily:"'DM Serif Display',serif", fontSize:24, color:'var(--teal-deeper)', marginBottom:12 }}>Pricing coming soon</h3>
            <p style={{ fontSize:15, color:'var(--text-mid)', marginBottom:24 }}>Contact us directly for a custom quote tailored to your family's needs.</p>
            <button className="btn-primary" onClick={() => go('consult')}>Get a quote →</button>
          </div>
        ) : (
          <div className="pricing-grid">
            {pricing.map(p => (
              <div key={p.id} style={{ background:'white', border:`${p.popular?'2px solid var(--teal)':'1px solid var(--border)'}`, borderRadius:16, padding:'1.75rem', textAlign:'center', position:'relative' }}>
                {p.popular && <div style={{ position:'absolute', top:-14, left:'50%', transform:'translateX(-50%)', background:'var(--teal)', color:'white', borderRadius:6, padding:'4px 14px', fontSize:11, fontWeight:700, whiteSpace:'nowrap' }}>MOST POPULAR</div>}
                <div style={{ fontSize:36, marginBottom:12 }}>{p.icon}</div>
                <div style={{ fontSize:13, fontWeight:700, color:'var(--text-light)', letterSpacing:1, textTransform:'uppercase', marginBottom:8 }}>{p.type}</div>
                <div style={{ fontFamily:"'DM Serif Display',serif", fontSize:34, color:'var(--teal-deeper)', lineHeight:1 }}>{p.price}</div>
                <div style={{ fontSize:13, color:'var(--text-light)', marginBottom:'1rem' }}>{p.unit}</div>
                <p style={{ fontSize:13, color:'var(--text-mid)', lineHeight:1.6, marginBottom:'1rem' }}>{p.description}</p>
                <div style={{ textAlign:'left' }}>
                  {p.features?.map(f => (
                    <div key={f} style={{ display:'flex', alignItems:'center', gap:6, fontSize:13, color:'var(--text-mid)', marginBottom:6 }}>
                      <span style={{ color:'var(--teal)', fontWeight:700 }}>✓</span>{f}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}

        <div style={{ background:'var(--teal-deeper)', borderRadius:12, padding:'16px 24px', textAlign:'center', marginBottom:'3rem' }}>
          <p style={{ fontSize:13, color:'rgba(255,255,255,.7)' }}>Rates are guidelines. Final pricing confirmed in writing. Alberta minimum wage ($15/hr) applies to all placements. <span style={{ color:'var(--teal-mid)', cursor:'pointer', textDecoration:'underline' }} onClick={() => go('consult')}>Contact us for a custom quote.</span></p>
        </div>

        <div style={{ background:'white', border:'1px solid var(--border)', borderRadius:16, padding:'1.75rem', marginBottom:'2rem' }}>
          <h3 style={{ fontFamily:"'DM Serif Display',serif", fontSize:22, color:'var(--teal-deeper)', marginBottom:'1rem' }}>About our agency fees</h3>
          <p style={{ fontSize:15, color:'var(--text-mid)', lineHeight:1.8, marginBottom:12 }}>Tinytrust Services charges a one-time placement fee for full-time and live-in nanny placements. This covers our full vetting process, matching service, introductions, and 30-day replacement guarantee.</p>
          <p style={{ fontSize:15, color:'var(--text-mid)', lineHeight:1.8 }}>Agency fees are communicated clearly in your service agreement before any placement begins. For babysitting and casual care, no placement fee applies.</p>
        </div>

        <div style={{ textAlign:'center' }}>
          <button className="btn-primary" style={{ fontSize:16, padding:'14px 36px' }} onClick={() => go('consult')}>Get a custom quote →</button>
        </div>
      </div>
    </div>
  );
}